export default __webpack_public_path__ + "static/logo-45036868b333604363f15c97b95ec3cb.png";